let postCards = document.getElementsByClassName("publicaciones--card");
let postPage = 1;
let limit;


if (Array.from(postCards).length > 1 ) {
	limit = 6;
	// console.log('publicaciones');
} else {
	postCards = document.getElementsByClassName("biblioteca--card");
	if (Array.from(postCards).length > 1 ){
		limit = 12;
		// console.log('biblioteca');
	} else {
		postCards = document.getElementsByClassName("events-card--archive");
		limit = 8;
		// console.log('eventos');
	}	
}

paginationNumbersArr = Math.ceil(Array.from(postCards).length / limit);
displayCards(limit);